import { usePromise } from '@issue-detail/utils/usePromise';
import { watch } from '@vue/composition-api';

import { getWorkflow } from '../Api/issue';
import { ActionStore } from './action';
import { IssueTypeStore } from './issueType';

export const useWorkflow = (
  actionStore: ActionStore,
  issueTypeStore: IssueTypeStore
) => {
  const { result: currentWorkflowInfo, refresh } = usePromise(
    (workflowId?: number) => (workflowId ? getWorkflow(workflowId) : undefined),
    undefined,
    { immediate: false }
  );

  watch(
    [actionStore.actionType, issueTypeStore.currentIssueType],
    () => {
      refresh(
        actionStore.actionType.value === 'Edit' &&
          issueTypeStore.currentIssueType.value
          ? issueTypeStore.currentIssueType.value.workflowId
          : undefined
      );
    },
    { immediate: true }
  );

  return { currentWorkflowInfo };
};

export type WorkflowStore = ReturnType<typeof useWorkflow>;
